var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"max-width":"100","items":_vm.roles,"rules":[_vm.required],"disabled":_vm.disabled},model:{value:(_vm.role),callback:function ($$v) {_vm.role=$$v},expression:"role"}})
}
var staticRenderFns = []

export { render, staticRenderFns }